import * as React from "react";
import Component from "../../AbstractComponent";

import { PromptDialog } from "./PromptDialog";
import { PageTransition } from "../../Partials/Spinner/PageTransition";
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import CompanyLookup from "../Lookup/CompanyLookup";
import TextField from "../Material/TextField";
import PaymentClassContainer from "../../../Entity/Entities/Payment/PaymentClass/PaymentClassContainer";
import Constants from "../../../Action/Constants";
import Formatter from "../../../Localization/Formatter";
import TypeContainer from "../../../Entity/Entities/Charge/Type/TypeContainer";
import Select from "../../Partials/Material/Select";
import ChargeClassContainer from "../../../Entity/Entities/Charge/ChargeClass/ChargeClassContainer";
import MenuItem from '@material-ui/core/MenuItem';

export class SettleWithSavingsDialog extends Component {
  protected timer;
  public defaultChargeTypeLabel: string = this.props.defaultChargeTypeLabel || null;
  public defaultChargeTypeId: string = this.props.defaultChargeTypeId || null;

  public state = {
    entity: null,
    isOpen: false,
    settleSavingScenarioMessage: "",
    isSaving: false,
    savingAccount: "owner",
    settleAccountOption: "owner",
    selectedCompany: null,
    savingsDescription: '',
    renderChargeType: true,
    chargeClassId: this.props.globalTypes?.ChargeType?.[this.defaultChargeTypeId]?.chargeClassId || 1,
    typeIdForCharge: this.props.typeIdForCharge || null,
    selectedCompanyError: '',
  };

  constructor(public props) {
    super(props);
  }

  public componentWillReceiveProps(nextProps) {
    if (nextProps.entity !== this.state.entity) {
      const selectedCompany = !nextProps.entity?.counterparty?.isAgency ? (nextProps.entity?.company?.name || nextProps.entity?.person?.companies?.find(company => company?.isOwner)) : null;
      this.setState({
        entity: nextProps.entity,
        savingsDescription: nextProps.entity.description ? `${nextProps.entity.description}` : `${this.trans("settlement-with-savings-description")}`,
        selectedCompany,
      });

      if (nextProps.entity?.nameForUrl === 'payment') {
        const paymentClassId = nextProps.entity?.paymentClass?.id;
        let typeIdForCharge: number;
 
        if (paymentClassId == PaymentClassContainer.pickIdFromLabel("Payable")) {
          typeIdForCharge = TypeContainer.pickIdFromLabel("Other_payable");
        } else {
          typeIdForCharge = TypeContainer.pickIdFromLabel("Other_receivable");
        }

        this.setState({
          chargeClassId: String(paymentClassId),
          typeIdForCharge: typeIdForCharge,
          selectedCompany,
        });
      }
    }

    if (nextProps.isOpen !== this.state.isOpen) {
      this.setState({
        isOpen: nextProps.isOpen
      });
    }


    if (nextProps.settleSavingScenarioMessage !== this.state.settleSavingScenarioMessage) {
      if (
        nextProps.entity?.nameForUrl === "charge"
        && nextProps.settleSavingScenarioMessage === "deposit_to_owner"
        ||nextProps.settleSavingScenarioMessage === "withdrawal_from_owner"
        ) {
        const owner = this.props.app?.companies?.find(company => company?.id === this.state.entity?.ownerId);
        if (owner) {
          this.setState({
            selectedCompany: owner
          });
        }
      } else if (
        this.state.settleSavingScenarioMessage === "choose_saving_account_for_withdraw" || this.state.settleSavingScenarioMessage === "choose_saving_account_for_deposit"
      ) {
        const selectedCompany = !this.props.entity?.counterparty?.isAgency ? (this.props.entity?.company?.name || this.props.entity?.person?.companies?.find(company => company?.isOwner)) : null;
        this.setState({
          selectedCompany,
        });
      }
     
      // const selectedCompany = !nextProps.entity?.counterparty?.isAgency
      // ? (this.state.entity?.company?.name
      //     || this.state.entity?.person?.companies?.find(company => company?.isOwner)?.name
      //   )
      // : null;
      this.setState({
        settleSavingScenarioMessage: nextProps.settleSavingScenarioMessage,
        // selectedCompany,
        savingAccount: (nextProps.settleSavingScenarioMessage === "deposit_to_agency" || "withdrawal_from_agency") && this.state.entity?.counterparty?.isAgency ? "agency" : "owner",
        settleAccountOption: (nextProps.settleSavingScenarioMessage === "deposit_to_agency" || "withdrawal_from_agency") && this.state.entity?.counterparty?.isAgency ? "agency" : "owner",
      });
    }
  }

  public onCloseDialog = () => {
    if (this.props.closeDialog) {
      this.props.closeDialog();

      this.clearState();
    }
  }

  public componentWillUnmount() {
    this.setState({
      entity: null,
      isOpen: false,
      settleSavingScenarioMessage: "",
      isSaving: false,
      savingAccount: "owner",
      savingsDescription: '',
      renderChargeType: true,
      chargeClassId: this.props.globalTypes?.ChargeType?.[this.defaultChargeTypeId]?.chargeClassId || 1,
      typeIdForCharge: this.props.typeIdForCharge || null,
      selectedCompanyError: '',

    })
  }

  public handleSelectCompany = (selectedCompany) => {
    this.setState({ selectedCompany: selectedCompany ?? null })
  }

  public handleSelectDifferentAccountForSettle = (settleAccountOption) => {
    this.setState({ settleAccountOption });
  }

  public clearState = () => {
    this.setState({
      entity: null,
      isOpen: false,
      isSaving: false,
      savingAccount: "owner",
      savingsDescription: '',
      renderChargeType: true,
      chargeClassId: this.props.globalTypes?.ChargeType?.[this.defaultChargeTypeId]?.chargeClassId || 1,
      typeIdForCharge: this.props.typeIdForCharge || null,
      selectedCompanyError: '',
    })
  }

  public save = () => {
    if (!this.props.entity) {
      return;
    }

    this.setState({
      isSelectedCompanyEmpty: ''
    });

    switch (this.props.entity?.nameForUrl) {
      case "charge":
        return this.settleWithSavingsCharge(this.props.entity);
      case "payment":
        return this.settleWithSavingsPayment(this.props.entity);
      default:
        break;
    }
  }

  public settleWithSavingsCharge = (charge) => {
    this.setState({
      isSaving: true
    });

    let companyId;
    if (this.state.settleAccountOption === "agency") {
      companyId = this.getAgency()?.id;
    } else {
      companyId = this.state.selectedCompany ? this.state.selectedCompany?.id : charge?.companyId 
    }
    //   if (!companyId &&
    //     this.state.entity?.nameForUrl === "charge"
    //     && this.state.settleSavingScenarioMessage === "deposit_to_owner"
    //     ||this.state.settleSavingScenarioMessage === "withdrawal_from_owner"
    //     ) {
    //     const owner = this.props.app?.companies?.find(company => company?.id === this.state.entity?.ownerId);
    //     if (owner) {
    //       companyId = owner.id
    //     }
    // }

    this.props.dispatch({
      type: Constants.GLOBAL_SETTLE_WITH_SAVINGS_ACCOUNT_START,
      payload: {
        chargeId: charge?.id,
        companyId: companyId,
        description: this.state.savingsDescription,
      },
      onSuccess: () => {
        this.props.dispatch({
          type: Constants.SAVED_DATA_BEFORE_REDIRECTING_CLEAR
        });

        this.setState({
          isSaving: false
        });

        this.props.dispatch({
          type: Constants.SNACKBAR_ADD_MESSAGE,
          payload: {
            message: this.trans("snackbar-message-settle-with-savings-successfully"),
            type: "success"
          }
        });

        return this.props.initializePage();
      },
      onError: () => {
        this.setState({
          isSaving: false,
        }, this.onCloseDialog);
      }
    });
  }
  public changeTypeIdForCharge = (...args: any[]): void => {
    if (!!args[1].props.value) {
      const type = this.getChargeTypeBySelect(args[1].props.value);

      this.setState({
        typeIdForCharge: type?.id,

      });
    }
  }

  public renderChargeType = (classId) => {

    return (
      <React.Fragment>
        <Select
          className="form-element full-size scroll-to-typeIdForCharge"
          error={this.getErrorFor("typeIdForCharge")}
          variant="standard"
          value={this.state.typeIdForCharge}
          onChange={this.changeTypeIdForCharge}
          htmlFor="type"
          label={this.trans("section/charge-field/type-label")}
          name="type"
          id="type"
        >
          {
            TypeContainer.getChargeTypes(Number(classId) == ChargeClassContainer.pickIdFromLabel("Payable") ? "payable" : "receivable")
              .filter(chargeType => {
                if ((TypeContainer.pickIdFromLabel("Savings_account_withdraw") === chargeType.id || TypeContainer.pickIdFromLabel("Savings_account_deposit") === chargeType.id) && (this.state.renderChargeType !== TypeContainer.pickIdFromLabel("Savings_account_withdraw") && this.state.renderChargeType !== TypeContainer.pickIdFromLabel("Savings_account_deposit"))) {
                  return false;
                }

                if ((TypeContainer.pickIdFromLabel("Stub_receivable") === chargeType.id || TypeContainer.pickIdFromLabel("Stub_payable") === chargeType.id) && (this.state.renderChargeType !== TypeContainer.pickIdFromLabel("Stub_receivable") && this.state.renderChargeType !== TypeContainer.pickIdFromLabel("Stub_payable"))) {
                  return false;
                }

                if (!!this.state.typeIdForCharge && chargeType.removed && (chargeType.id === this.state.typeIdForCharge)) {
                  return true;
                }

                if (chargeType.removed) {
                  return false;
                }

                return true;
              })
              .map((type, index) => {
                return (
                  <MenuItem key={`chargeType-${index}`} value={type.id} disabled={(type.id === -1 || type.id === -2)}>{`${type.id === -1 || type.id === -2 ? type.label : Formatter.checkTranslationType(this.trans(type?.label, {}, "", type?.system), type?.label, type?.system)}`}</MenuItem>
                );
              })
          }
          {
            (TypeContainer.pickIdFromLabel("Credit_receivable") === this.state?.typeIdForCharge || TypeContainer.pickIdFromLabel("Credit_payable") === this.state?.typeIdForCharge) && <MenuItem key={`chargeType-${this.state?.typeIdForCharge}`} value={this.state?.typeIdForCharge}>{this.trans(`${TypeContainer.pickIdFromLabel("Credit_payable") === this.state?.typeIdForCharge ? "credit_payable" : "credit_receivable"}`)}</MenuItem>
          }
        </Select>
      </React.Fragment>
    );
  }
  public getChargeTypeBySelect = (id) => {
    const chargeType = this.props.globalTypes?.ChargeType;
    if (!!id) {
      for (const key in chargeType) {
        if (chargeType[key].id === id) {
          return chargeType[key];
        }
      }
    }
  }

  public settleWithSavingsPayment = (payment) => {
    // const isSelectedCompanyEmpty = this.isFieldEmpty("selectedCompany", this.state?.selectedCompany);
    // if (isSelectedCompanyEmpty) {
    //   return this.setState({
    //     selectedCompanyError: isSelectedCompanyEmpty ? this.trans("this-field-is-required") : "",
    //   })
    // }
    this.setState({
      isSaving: true
    });

    let companyId;

    if ((this.state.settleSavingScenarioMessage === "deposit_to_agency" ||
      this.state.settleSavingScenarioMessage === "withdrawal_from_agency") &&
      this.state.settleAccountOption === "owner"
    ) {
      companyId = this.state.selectedCompany?.id;
    } else if (
      (this.state.settleSavingScenarioMessage === "deposit_to_agency" ||
        this.state.settleSavingScenarioMessage === "withdrawal_from_agency") &&
      this.state.settleAccountOption === "agency"
    ) {
      companyId = this.getAgency()?.id;
    }
    else {
      if (this.state.savingAccount === "agency") {
        companyId = this.getAgency()?.id;
      } else {
        companyId = payment?.companyId;

        if (!companyId) {
          companyId = payment?.person?.companies?.find(company => company?.isOwner)?.id;
        }
      }
    }

    this.props.dispatch({
      type: Constants.GLOBAL_SETTLE_PAYMENT_WITH_SAVINGS_ACCOUNT_START,
      payload: {
        paymentId: payment?.id,
        companyId: companyId,
        description: this.state.savingsDescription,
        type: this.state.typeIdForCharge,
      },
      onSuccess: () => {
        this.props.dispatch({
          type: Constants.SAVED_DATA_BEFORE_REDIRECTING_CLEAR
        });



        this.props.dispatch({
          type: Constants.SNACKBAR_ADD_MESSAGE,
          payload: {
            message: this.trans("snackbar-message-settle-with-savings-successfully"),
            type: "success"
          }
        });

        return this.props.initializePage(() => {
          this.setState({
            isSaving: false,
            isPaymentSettleWithSavingsPopupOpen: false
          });

        });
      },
      onError: () => {
        this.setState({
          isPaymentSettleWithSavingsPopupOpen: false,
          isSaving: false,
        }, this.onCloseDialog);
      }
    });
  }

  public chooseSavingAccount = (event) => {

    const choice: string = event.target.value;
    this.setState({
      savingAccount: choice,
    });
  }

  public renderContent = () => {
    let infoText = "";
    if (
      this.state.settleSavingScenarioMessage === "deposit_to_agency"
      || this.state.settleSavingScenarioMessage === "withdrawal_from_agency"
      ) {
      infoText = this.trans("dialog/preprocess-settlewithsavings/info-select-acc", 
        { savingsAmount: this.formatter.formatNumber(this.state.entity?.amountRemaining, this.props.app.settings.user.currency) });
    } else if (
      this.state.entity?.nameForUrl === "charge"
      && this.state.settleSavingScenarioMessage === "deposit_to_owner"
      || this.state.settleSavingScenarioMessage === "withdrawal_from_owner"
      ) {
      const owner = this.props.app?.companies?.find(company => company?.id === this.state.entity?.ownerId);
      infoText = `${this.trans(this.state.settleSavingScenarioMessage, { savingsAmount: this.formatter.formatNumber(this.state.entity?.amountRemaining, this.props.app.settings.user.currency) })} ${owner?.displayName || ""}`;
    } else if (this.state.settleSavingScenarioMessage !== "") {
      infoText = this.trans(this.state.settleSavingScenarioMessage)
    }

    return (
      <div style={{ minHeight: '475px' }}>
        <div>{infoText}</div>
        {(this.state.settleSavingScenarioMessage === "deposit_to_agency" || this.state.settleSavingScenarioMessage === "withdrawal_from_agency") && (
          <div>
            <RadioGroup
              className="filters-container"
              value={this.state.settleAccountOption}
              onChange={e => this.setState({ settleAccountOption: e.target.value })}
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-start",
                padding: "10px 0 0 10px",
                width: "500px",
                paddingLeft: "0px"
              }}
            >
              {!this.state.entity?.counterparty?.isAgency &&
                <FormControlLabel
                  control={<Radio color="primary" />}
                  value="owner"
                  onClick={() => this.handleSelectDifferentAccountForSettle("owner")}
                  label={this.trans('dialog/preprocess-settlewithsavings/select-owner')}
                  style={{ width: "auto", fontSize: "16px", marginRight: "20px" }}
                />
              }
              <FormControlLabel
                control={<Radio color="primary" />}
                value="agency"
                label={this.getAgency()?.name}
                onClick={() => this.handleSelectDifferentAccountForSettle("agency")}
                style={{ width: "auto", fontSize: "16px", marginRight: "20px" }}
              />
            </RadioGroup>

            {this.state.settleAccountOption === "owner" && !this.state.entity?.counterparty?.isAgency && (
              <CompanyLookup
                {...this.props}
                id="selectedCompanyForPayment"
                name="selectedCompanyForPayment"
                ref="selectedCompanyForPaymentLookup"
                className="scroll-to-selectedCompanyForPayment"
                isInlineBlock={false}
                width="100%"
                containerWidth="100%"
                forceUpdatePage={true}
                additionalClasses="settle-dialog"
                disableEntityCreation={true}
                autoSelectId={null} // this.state.selectedCompanyForPayment?.id
                floatingLabelText={this.trans("dropdown-searchforcompany-label")}
                onSelect={this.handleSelectCompany}
                onClear={this.handleSelectCompany}
                saveDetailsBeforeRedirect={() => { }}
                error={this.getErrorFor("selectedCompanyForPayment")}
                disabled={false}
                filterAgency={true}
                filterOwner={true}
                required={true}
                
              />
            )}
          </div>
        )}
        {(this.state.settleSavingScenarioMessage === "choose_saving_account_for_withdraw" || this.state.settleSavingScenarioMessage === "choose_saving_account_for_deposit") &&
          <div>
            <RadioGroup
              className="filters-container"
              value={this.state.savingAccount}
              onChange={e => this.chooseSavingAccount(e)}
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-start",
                padding: "10px 0 0 10px",
                width: "500px",
                paddingLeft: "0px"
              }}
            >
              {!this.state.entity?.counterparty?.isAgency && (this.state.entity?.company?.name || this.state.entity?.person?.companies?.find(company => company?.isOwner)?.name) &&
                <FormControlLabel
                  control={<Radio color="primary" />}
                  value="owner"
                  label={this.state.entity?.company?.name || this.state.entity?.person?.companies?.find(company => company?.isOwner)?.name}
                  style={{ width: "auto", fontSize: "16px", marginRight: "20px" }}
                />
              }
              <FormControlLabel
                control={<Radio color="primary" />}
                value="agency"
                label={this.getAgency()?.name}
                style={{ width: "auto", fontSize: "16px", marginRight: "20px" }}
              />
            </RadioGroup>
          </div>
        }
        <TextField
          autoComplete="off"
          className="form-element full-size scroll-to-description"
          type="text"
          multiline
          rowsMax="25"
          rows="3"
          label={this.trans("description")}
          value={this.state.savingsDescription}
          onChange={e => this.setState({ savingsDescription: e.target.value })}
          variant="standard"
          error={!!this.getErrorFor("description")}
        />
        {this.state.entity?.nameForUrl === "payment" && (
          this.renderChargeType(this.state.chargeClassId)
        )}
      </div>
    );
  }

  public render() {
    return (
      <div>
        <PromptDialog
          {...this.props}
          openLeavePrompt={this.props.isOpen}
          title={this.trans("dialog/preprocess-settlewithsavings/title")}
          content={this.renderContent()}
          positiveButtonLabel={this.state.settleSavingScenarioMessage === "it_is_not_possible_to_make_savings_action" ? this.trans("dialog-button/close") : this.trans("button-settle")}
          disablePositiveButton={this.state.settleSavingScenarioMessage !== 'it_is_not_possible_to_make_savings_action' && !this.state.entity && this.state.settleAccountOption === "owner"}
          negativeButtonLabel={this.trans("dialog-button/cancel")}
          onlyPositiveButton={this.state.settleSavingScenarioMessage === "it_is_not_possible_to_make_savings_action"}
          onSave={() => {
            if (this.state.settleSavingScenarioMessage === "it_is_not_possible_to_make_savings_action") {
              this.onCloseDialog();
            } else {
              this.onCloseDialog();
              this.save();
            }
          }}
          onDiscard={() => this.onCloseDialog()}
        />

        <PageTransition isSaving={this.state.isSaving} />
      </div>
    );
  }
}
